(function() {

  const getPackagingIds = () => (window.PACKAGING_PRODUCT_IDS || []).map(String);

  let _cachedCart = null;

  async function getCart() {
    return fetch('/cart.js').then(r => r.json());
  }

  async function setCartState() {
    _cachedCart = await getCart();
    const packagingIds = getPackagingIds();

    const packagingItem = _cachedCart.items.find(item => packagingIds.includes(String(item.product_id)));
    if (packagingItem && packagingItem.quantity > 1) {
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: { [packagingItem.key]: 1 } })
      });
      window.trigger('theme:cart:refresh');
      return;
    }

    const hasWine = _cachedCart.items.some(item => !packagingIds.includes(String(item.product_id)));
    const drawerEl = document.querySelector('cart-element[data-view="drawer"]');
    drawerEl?.classList.toggle('has-wine', hasWine);

    if (hasWine) {
      drawerEl?.classList.remove('cart-is-empty');
      const radios = document.querySelectorAll('.js-packaging-option');
      syncRadio(_cachedCart, packagingIds, radios);
    }
  }

  function syncRadio(cart, packagingIds, radios) {
    const packagingInCart = cart.items.find(item => packagingIds.includes(String(item.product_id)));
    if (!packagingInCart) return;
    radios.forEach(r => {
      r.checked = r.getAttribute('data-variant-id') === String(packagingInCart.variant_id);
    });
  }

  // Initialise immediately
  setCartState().then(() => {
    window.addEventListener('theme:drawer:right:opened', async function() {
      const drawerEl = document.querySelector('cart-element[data-view="drawer"]');
      const emptyEl = drawerEl?.querySelector('.cart--empty');

      if (emptyEl) emptyEl.style.visibility = 'hidden';

      await setCartState();

      if (!drawerEl?.classList.contains('has-wine')) {
        drawerEl?.classList.add('cart-is-empty');
        if (emptyEl) emptyEl.style.visibility = 'visible';
      }
    });
  });

  window.addEventListener('theme:cart:updated', setCartState);

  // Set has-wine immediately when add to cart clicked to prevent empty state flash
  document.body.addEventListener('click', function(e) {
    if (e.target.closest('[name="add"], .product-buy-buttons--primary, [data-add-to-cart]')) {
      const drawerEl = document.querySelector('cart-element[data-view="drawer"]');
      drawerEl?.classList.add('has-wine');
      drawerEl?.classList.remove('cart-is-empty');
    }
  });

  // Add default packaging when product added to cart
  window.addEventListener('theme:cart:productAdded', async function(e) {
    try {
      const packagingIds = getPackagingIds();
      const addedVariantId = String(e.detail);
      if (packagingIds.some(id => addedVariantId === id)) return;

      const cart = await getCart();

      const hasPackaging = cart.items.some(item => packagingIds.includes(String(item.product_id)));
      if (hasPackaging) return;

      const defaultVariantId = window.DEFAULT_PACKAGING_VARIANT_ID;
      if (!defaultVariantId) return;

      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(defaultVariantId), quantity: 1 })
      });

      window.trigger('theme:cart:refresh');

    } catch (err) {
      console.error('Default packaging add error:', err);
    }
  });

  // When remove clicked on last wine — intercept and clear cart
  document.body.addEventListener('click', function(e) {
    const removeBtn = e.target.closest('.quantity-selector--remove');
    if (!removeBtn) return;
    if (!_cachedCart) return;

    const packagingIds = getPackagingIds();
    const wineItems = _cachedCart.items.filter(item => !packagingIds.includes(String(item.product_id)));

    if (wineItems.length !== 1) return;

    e.stopImmediatePropagation();
    e.preventDefault();

    fetch('/cart/clear.js', { method: 'POST' }).then(() => {
      const drawerEl = document.querySelector('cart-element[data-view="drawer"]');
      const emptyEl = drawerEl?.querySelector('.cart--empty');
      drawerEl?.classList.add('cart-is-empty');
      drawerEl?.classList.remove('has-wine');
      if (emptyEl) emptyEl.style.visibility = 'visible';
      setCartState();
    });

  }, true);

  // Radio change — swap packaging
  document.body.addEventListener('change', async function(e) {
    const radio = e.target.closest('.js-packaging-option');
    if (!radio || !radio.checked) return;

    const newVariantId = radio.getAttribute('data-variant-id');
    document.querySelectorAll('.js-packaging-option').forEach(r => r.disabled = true);

    try {
      const cart = await getCart();
      const packagingIds = getPackagingIds();

      const updates = {};
      cart.items.forEach(item => {
        if (packagingIds.includes(String(item.product_id))) updates[item.key] = 0;
      });

      if (Object.keys(updates).length > 0) {
        await fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ updates })
        });
      }

      const addResponse = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(newVariantId), quantity: 1, sections: ['cart-drawer'] })
      });
      const data = await addResponse.json();
      const html = data.sections['cart-drawer'];
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const newTotal = doc.querySelector('.cart--total-price');
      const existingTotal = document.querySelector('cart-element[data-view="drawer"] .cart--total-price');
      if (newTotal && existingTotal) existingTotal.replaceWith(newTotal);

      document.querySelectorAll('.js-packaging-option').forEach(r => {
        r.checked = r.getAttribute('data-variant-id') === newVariantId;
      });

    } catch (err) {
      console.error('Packaging swap error:', err);
    } finally {
      document.querySelectorAll('.js-packaging-option').forEach(r => r.disabled = false);
    }
  });

})();